import React, {Component} from 'react'
import ReactPlayer from 'react-player'
import {useTranslation} from 'react-i18next'
import {useSelector} from 'react-redux'



const MyReactPlayer = () => {
  return (
    <div style={{ position: 'relative', width: '100%', height: '500px' }}>
      <ReactPlayer
        url="https://cdn.mannheim-urology.com/videos/hivec-video-1.mp4"
        width="100%"
        height="100%"
        controls={true} startTime={7.0} playing={false}
        style={{ position: 'absolute', top: 0, left: 0 }} 
      />
    </div>
  );
};




const TesticularHealth = () => {
    const {t} = useTranslation()
    const language = useSelector(state => state.language)
    switch (language) {
        case 'BG':
            return (
                <section id="about1">
                    <div className="row">
 
                        <p className="white">
<h2>Тестикуларен тумор:</h2>
<p>Ракът на тестисите е сравнително рядко заболяване, което засяга приблизително 4000 мъже в Германия всяка година, по данни на Института "Робърт Кох". Добрата новина обаче е, че ракът на тестисите практически винаги може да бъде излекуван в ранните му стадии, а дори и в напредналите стадии има добри шансове за излекуване. Ето защо е важно да познавате рисковите фактори, симптомите и диагностиката, за да го откриете възможно най-рано.</p>
<h2>Рискови фактори:</h2>
<p>Въпреки че точните причини за появата на рак на тестисите не са окончателно установени, недоразвитите тестиси и наследственото предразположение са потвърдени рискови фактори.</p>
<h2>Симптоми:</h2>
<p>Мъжете обикновено сами могат да открият първите признаци на рак на тестисите. Препоръчва се внимателно да се палпират двата тестиса на редовни интервали от време в отпуснато положение. Типичен симптом на тумор на тестисите е предимно безболезнено уголемяване и втвърдяване на тестиса. Само при палпация на тестисите се откриват над 80 % от туморите. Други ранни симптоми на заболяването включват:</p>
<ul>
    <li>Безболезнено или болезнено подуване или бучка на тестиса</li>
    <li>Усещане за тежест или придърпване на тестиса или в слабините</li>
    <li>Уголемяване на тестиса</li>
    <li>Болка в гърба поради уголемяване на лимфните възли в корема</li>
    <li>Подуване или болезненост на млечните жлези (едната или двете гърди)</li>
</ul>
<p>При поява на някой от тези симптоми или забелязване на аномалии в тестисите, задължително трябва да се извърши урологичен преглед.</p>
<h2>Диагностика:</h2>
<p>Първоначалната диагностика на рака на тестисите включва физически преглед с палпация на тестисите, лимфните възли и ултразвуково изследване на тестисите. Важно е също така да се определят някои туморни маркери и изследвания на микроРНК, като например miRNA-371-1, което е стандартно препоръчително изследване за наличие на рак на тестисите в много урологични практики. Микрорибонуклеиновите киселини (miRNA) са малки парченца РНК, които се намират в клетките и телесните течности, като кръвта и урината. При рак на тестисите е установена миРНК (miR-371) за диагностициране на рак на тестисите в кръвта.</p>
<h2>Терапия:</h2>
<p>Хирургичното отстраняване на подозрителния тестис е окончателното лечение на рака на тестисите. Обикновено въпросният тестис се отстранява напълно. Ако са налице рискови фактори за определена предразположеност към рак, трябва да се извърши двойна биопсия на другия тестис. Останалият тестис от противоположната страна обикновено поема функцията на отстранения тестис, така че в резултат на тази операция рядко се появяват дългосрочни странични ефекти като безплодие, импотентност или нарушено сексуално изживяване. </p>
<h2>Проследяване на тумора:</h2>
<p>Честотата и видът на проследяването зависят от клиничните фактори, като например вида на тумора, стадия на тумора и проведеното лечение. Използването на нови туморни тестове за микроРНК (miR371) може да доведе до опрости проследяването. Поради това се препоръчва редовно урологично проследяване, за да се открие евентуална повторна поява на тумора. Важно е също така да се отбележи, че след приключване на лечението преживелите рак на тестисите трябва да са наясно с риска от развитието на други видове рак, като например рак на белия дроб или меланом, и да потърсят лекарски съвет, ако забележат някакви нови симптоми. </p>
                        </p>
                    </div>
                </section>
            )
        default:
            return (
                <section id="about1">
                    <div className="row">
 
                                <h2>Testicular health check-up</h2>
                            <p>
<h2>Testicular Tumor:</h2>
<p>Testicular cancer is a relatively rare disease affecting approximately 4000 men in Germany each year, according to the Robert Koch Institute. However, the good news is that testicular cancer can be practically always cured in its early stages, and even in advanced stages, there is a good chance of cure. Therefore, it is important to know the risk factors, symptoms, and diagnostics to detect it as early as possible.</p>
<h2>Risk factors:</h2>
<p>Although the exact causes of testicular cancer have not been conclusively determined, undescended testicles and a hereditary predisposition are confirmed risk factors.</p>
<h2>Symptoms:</h2>
<p>Men can usually detect the first signs of testicular cancer themselves. It is recommended to carefully palpate both testicles at regular intervals in a relaxed position. A typical symptom of a testicular tumor is a mostly painless enlargement and hardening of the testicle. Palpation of the testicles alone detects more than 80% of tumors. Other early symptoms of the disease include:</p>
<ul>
    <li>A painless or painful swelling or lump on the testicle</li>
    <li>A feeling of heaviness or pulling on the testicle or in the groin</li>
    <li>Enlargement of the testicle</li>
    <li>Back pain due to enlargement of lymph nodes in the abdomen</li>
    <li>A swelling or painfulness of the mammary glands (one or both breasts)</li>
</ul>
<p>If any of these symptoms occur or abnormalities are noticed in the testicles, a urological examination should definitely be performed.</p>
<h2>Diagnostics:</h2>
<p>The initial diagnostics for testicular cancer include a physical examination with palpation of the testicles, lymph nodes, and a testicular ultrasound examination. It is also important to determine certain tumor markers and microRNA examinations, such as miRNA-371-1, which is a standard recommended test for the presence of testicular cancer in many urology practices. Micro Ribonucleic Acids (miRNAs) are tiny pieces of RNA found in cells and body fluids such as blood and urine. In testicular cancer, a miRNA (miR-371) has been established for the diagnosis of testicular cancer in blood.</p>
<h2>Therapy:</h2>
<p>Surgical exposure of the suspicious testis is the definitive treatment for testicular cancer. Usually, the testis in question is completely removed. If risk factors for certain predisposition to cancer are present, a double biopsy of the other testicle should be performed. The remaining testicle on the opposite side usually takes over the function of the removed testicle, so long-term side effects such as infertility, impotence, or impaired sexual experience rarely occur as a result of this surgery.</p>
<h2>Tumor follow-up:</h2>
<p>The frequency and type of follow-up depend on the clinical factors such as tumor type, tumor stage, and treatment performed. The use of novel tumor tests for microRNA (miR371) may simplify follow-up. Therefore, regular urological follow-up is recommended to detect any recurrence of the tumor. It is also important to note that after completing the treatment, testicular cancer survivors should be aware of the risk of developing other cancers, such as lung cancer or melanoma, and seek medical advice if they notice any new symptoms.</p>
                                <hr/>
 
                            </p>
 
                    </div>
                </section>
            )
    }


}

export default TesticularHealth



// WEBPACK FOOTER //
// ./src/Components/TesticularHealth.js